import { render } from "./hit-show.vue?vue&type=template&id=9cf62d7e"
import script from "./hit-show.vue?vue&type=script&lang=js"
export * from "./hit-show.vue?vue&type=script&lang=js"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__